import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { List, Tooltip, Button } from 'antd';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import { api, apis, ProductAuthorityFeature, apiHolder } from 'api';
import { comIsShowByAuth } from '@web-common/utils/utils';
import classnames from 'classnames';
import { MailRefreshIcon, MailModalCloseIcon } from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import './index.scss';
import AvatarTag from '@web-common/components/UI/Avatar/avatarTag';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import { inWindow } from 'api';
import { getIn18Text } from 'api';
import MailReadList from './read-list';
import Icon from '@ant-design/icons/es/components/Icon';
import { useContactModel } from '@web-common/hooks/useContactModel';
const RefreshIcon = (props) => React.createElement(Icon, Object.assign({ component: MailRefreshIcon }, props));
const CloseIcon = (props) => React.createElement(Icon, Object.assign({ component: MailModalCloseIcon }, props));
const StatusItem = props => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const { item, isReadStatus, wordSeparator, isLoadingReadList, allReadList, modifiedTime, _account, forbid = false } = props;
    const model = useContactModel({ contactId: (_a = item === null || item === void 0 ? void 0 : item.contact) === null || _a === void 0 ? void 0 : _a.contactId, email: item.email || ((_b = item === null || item === void 0 ? void 0 : item.contact) === null || _b === void 0 ? void 0 : _b.accountName), name: item.contactName, _account });
    const contactName = ((_c = model === null || model === void 0 ? void 0 : model.contact) === null || _c === void 0 ? void 0 : _c.contactName) || (item === null || item === void 0 ? void 0 : item.contactName);
    const email = (item === null || item === void 0 ? void 0 : item.contact) ? contactApi.doGetModelDisplayEmail(item.contact) : item.email;
    return (React.createElement(React.Fragment, null,
        React.createElement(List.Item, { extra: isReadStatus && item.status != 'outdomain' && React.createElement("div", { className: "u-item-time" }, isReadStatus ? item.text : modifiedTime) },
            React.createElement(List.Item.Meta, { avatar: React.createElement(AvatarTag, { style: { marginRight: '12px', marginLeft: '6px' }, size: 32, contactId: (_e = (_d = item === null || item === void 0 ? void 0 : item.contact) === null || _d === void 0 ? void 0 : _d.contact) === null || _e === void 0 ? void 0 : _e.id, propEmail: item.email || ((_f = item === null || item === void 0 ? void 0 : item.contact) === null || _f === void 0 ? void 0 : _f.accountName), user: {
                        name: (_h = (_g = item === null || item === void 0 ? void 0 : item.contact) === null || _g === void 0 ? void 0 : _g.contact) === null || _h === void 0 ? void 0 : _h.contactName,
                        avatar: (_k = (_j = item === null || item === void 0 ? void 0 : item.contact) === null || _j === void 0 ? void 0 : _j.contact) === null || _k === void 0 ? void 0 : _k.avatar,
                        color: (_m = (_l = item === null || item === void 0 ? void 0 : item.contact) === null || _l === void 0 ? void 0 : _l.contact) === null || _m === void 0 ? void 0 : _m.color,
                    } }), title: React.createElement(React.Fragment, null,
                    React.createElement(Tooltip, { title: contactName, mouseEnterDelay: 1, mouseLeaveDelay: 0.15 },
                        React.createElement("div", { className: "u-item-name" }, contactName)),
                    !isReadStatus && (React.createElement("div", { className: classnames(['u-item-status', item.status == 'suc' || (item === null || item === void 0 ? void 0 : item.rclResult) === 9 ? 'u-suc' : '']), style: { color: item.color } }, item.status == 'suc'
                        ? getIn18Text('CHEHUICHENGGONG') + wordSeparator
                        : item.status == 'fail' || (item === null || item === void 0 ? void 0 : item.rclResult) === 9
                            ? getIn18Text('CHEHUISHIBAI') + wordSeparator
                            : item.text))), description: React.createElement(React.Fragment, null,
                    React.createElement(Tooltip, { title: email, mouseEnterDelay: 1, mouseLeaveDelay: 0.15 },
                        React.createElement("div", { className: "u-item-email" }, email)),
                    !isReadStatus && React.createElement("div", { className: "u-item-time" }, isReadStatus ? item.text : modifiedTime)) })),
        isReadStatus && (React.createElement(MailReadList, { isLoadingReadList: isLoadingReadList, item: item, forbid: forbid, readList: allReadList && allReadList.length ? allReadList.filter(readItem => readItem.toAddr === email) : [] }))));
};
const systemApi = apiHolder.api.getSystemApi();
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const StatusModal = ({ visible, readListData, refreshData, onClose, onUpgradeModel, onProductModal, tid, account, forbid }) => {
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const timeZone = mailConfApi.getTimezone();
    const [allReadList, setAllReadList] = useState([]);
    const [isLoadingReadList, setIsLoadingReadList] = useState(false);
    const [isRefresh, setIsRefresh] = useState(false);
    const loadReadList = () => {
        if (tid) {
            setIsLoadingReadList(true);
            setIsRefresh(true);
            mailApi.getMailReadList(tid, account).then(res => {
                if (!res.success) {
                    setAllReadList([]);
                }
                else {
                    setAllReadList(res.data || []);
                }
                setIsLoadingReadList(false);
                setTimeout(() => {
                    setIsRefresh(false);
                }, 1000);
            });
        }
    };
    useEffect(() => {
        loadReadList();
    }, [tid]);
    const [tabIndex, setTabIndex] = useState(0);
    const [tabList, setTabList] = useState([]);
    const [listData, setListData] = useState();
    const [status, setStatus] = useState();
    const refreshList = () => {
        if (refreshData) {
            setTabIndex(0);
            setStatus('');
            refreshData();
        }
        loadReadList();
    };
    const isReadStatus = (readListData === null || readListData === void 0 ? void 0 : readListData.isrcl) ? false : true;
    const wordSeparator = inWindow() && window.systemLang === 'en' ? ' ' : '';
    const UnpermissionEle = () => {
        return (React.createElement("div", { className: "u-status-list-unPermission" },
            React.createElement("div", { className: "icon" }),
            React.createElement("div", { className: "content" },
                React.createElement("span", null, getIn18Text('SHENGJIFUWUTAO')),
                React.createElement("span", { className: "u-status-learn", onClick: onProductModal }, getIn18Text('LEJIEFUWUTAO'))),
            comIsShowByAuth(ProductAuthorityFeature.ADMIN_SITE_ENTRANCE_SHOW, React.createElement(Button, { type: "primary", onClick: onUpgradeModel }, getIn18Text('LIJISHENGJI')))));
    };
    const ListEle = () => {
        return (React.createElement(List, { itemLayout: "horizontal", header: status == 'unkown'
                ?
                    null
                : (readListData === null || readListData === void 0 ? void 0 : readListData.isrcl) && status !== 'fail'
                    ? getIn18Text('CHEHUICHENGGONGHOU')
                    : '', dataSource: listData, locale: {
                emptyText: (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "u-status-empty-img" }),
                    getIn18Text('MEIYOUNEIRONG'))),
            }, renderItem: item => {
                const modifiedTime = dayjs(systemApi.getDateByTimeZone(item.modifiedTime, timeZone, true)).format('YYYY-MM-DD HH:mm:ss');
                const email = (item === null || item === void 0 ? void 0 : item.contact) ? contactApi.doGetModelDisplayEmail(item.contact) : item.email;
                return (React.createElement(StatusItem, { item: item, modifiedTime: modifiedTime, isReadStatus: isReadStatus, wordSeparator: wordSeparator, isLoadingReadList: isLoadingReadList, allReadList: allReadList, _account: account, forbid: forbid }));
            } }));
    };
    const isEnglish = window.systemLang === 'en';
    const UpdateTabEle = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "u-status-list-tips", style: { height: isEnglish ? 'auto' : '50px' } },
                React.createElement("div", { className: "u-status-list-contain" },
                    getIn18Text('SHENGJIZUNXIANGBAN'),
                    React.createElement("span", { className: "u-status-learn", onClick: onProductModal }, getIn18Text('LEJIEFUWUTAO')),
                    comIsShowByAuth(ProductAuthorityFeature.ADMIN_SITE_ENTRANCE_SHOW, React.createElement(Button, { type: "primary", onClick: onUpgradeModel, style: { width: isEnglish ? 'auto' : '100px' } }, getIn18Text('LIJISHENGJI')))))));
    };
    const RenderEle = () => {
        if (productVersionId === 'sirius') {
            return ListEle();
        }
        if (status === 'unkown' || status === 'fail' || !status) {
            return ListEle();
        }
        else {
            if (productVersionId === 'free') {
                return UnpermissionEle();
            }
            else {
                return ListEle();
            }
        }
    };
    const RenderUpdateTips = () => {
        if (productVersionId === 'sirius') {
            return null;
        }
        if (!status || status === 'unkown') {
            return UpdateTabEle();
        }
        return null;
    };
    const ResetListHeight = () => {
        if (productVersionId === 'sirius') {
            return '350px';
        }
        if (status === 'read' || status === 'unread') {
            return '350px';
        }
        return '300px';
    };
    const handleStatusChange = index => {
        setTabIndex(index);
        if (readListData === null || readListData === void 0 ? void 0 : readListData.isrcl) {
            setStatus(['', 'suc', 'fail'][index]);
        }
        else {
            setStatus(['', 'read', 'unread', 'unkown'][index]);
        }
    };
    useEffect(() => {
        var _a;
        if (!status) {
            setListData(readListData === null || readListData === void 0 ? void 0 : readListData.data);
            return;
        }
        const _listData = (_a = readListData === null || readListData === void 0 ? void 0 : readListData.data) === null || _a === void 0 ? void 0 : _a.filter(item => {
            if (status === 'fail') {
                return item.status === status || item.status === 'unkown';
            }
            if (status === 'unkown') {
                return item.status === status || item.status === 'outdomain';
            }
            return item.status === status;
        });
        setListData(_listData);
    }, [status]);
    useEffect(() => {
        if (productVersionId === 'free') {
            handleStatusChange(3);
        }
    }, [productVersionId]);
    useEffect(() => {
        var _a;
        const sucList = [];
        const failList = [];
        const readList = [];
        const unreadList = [];
        const unkownList = [];
        if (readListData) {
            setListData(readListData.data);
            if ((_a = readListData.data) === null || _a === void 0 ? void 0 : _a.length) {
                readListData.data.forEach(item => {
                    if (item.status == 'suc') {
                        sucList.push(item);
                    }
                    else if (item.status == 'fail') {
                        failList.push(item);
                    }
                    else if (item.status == 'read') {
                        readList.push(item);
                    }
                    else if (item.status == 'unread') {
                        unreadList.push(item);
                    }
                    else {
                        unkownList.push(item);
                    }
                });
            }
            if (readListData.isrcl) {
                setTabList([getIn18Text('QUANBU'), `撤回成功(${sucList.length})`, `撤回失败(${failList.length})`]);
            }
            else {
                setTabList([
                    getIn18Text('QUANBU'),
                    `${getIn18Text('YIDU')}(${readList.length})`,
                    `${getIn18Text('WEIDU')}(${unreadList.length})`,
                    `${getIn18Text('WEIZHI')}(${unkownList.length})`,
                ]);
            }
        }
    }, [readListData]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { footer: null, visible: visible, width: 700, wrapClassName: "status-modal-wrap", closeIcon: React.createElement("div", { className: "u-status-icon dark-svg-invert" },
                React.createElement("span", { className: "icons", style: { cursor: 'pointer' }, onClick: () => refreshList() },
                    React.createElement(RefreshIcon, { spin: isRefresh })),
                React.createElement("span", { className: "icons", style: { cursor: 'pointer' }, onClick: () => {
                        onClose();
                        setTabIndex(0);
                    } },
                    React.createElement(CloseIcon, null))), isGlobal: !systemApi.isMainPage(), getContainer: document.body },
            React.createElement("div", { className: "u-status", style: { paddingTop: '73px' } },
                React.createElement("div", { className: "u-status-header" },
                    React.createElement("div", { className: "u-status-title" }, (readListData === null || readListData === void 0 ? void 0 : readListData.isrcl) ? getIn18Text('CHEHUIJIEGUO') : getIn18Text('YUEDUZHUANGTAI')),
                    React.createElement("div", { className: "u-status-tab" }, tabList.map((item, index) => (React.createElement("span", { className: classnames(['u-status-text', index == tabIndex ? 'on' : '']), onClick: e => handleStatusChange(index), key: index }, item))))),
                RenderUpdateTips(),
                React.createElement("div", { className: "u-status-list", style: { height: ResetListHeight() } }, RenderEle())))));
};
export default StatusModal;
